import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function BackButton({ to, label = "Voltar" }) {
  const navigate = useNavigate();
  function handleClick() {
    if (to) navigate(to);
    else navigate(-1);
  }
  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid="back-button"
      className="inline-flex items-center gap-1 -ml-1 mb-3 px-2 py-1.5 rounded-lg text-sm font-medium text-slate-600 hover:text-[#00357C] hover:bg-slate-100 active:scale-[0.98] transition-all"
    >
      <ChevronLeft size={18} />
      {label}
    </button>
  );
}
